<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>add</mat-icon>
      Add Price Option/Supplement
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-form-field>
      <mat-label>Price Label</mat-label>
      <input formControlName="priceOption" matInput type="text" />
    </mat-form-field>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
    >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid"
      mat-button
      matTooltip="Save ticket."
      type="submit"
    >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
